
import Vue from 'vue'
import index from '../page/App.vue'
import list from '../page/list.vue'
import classifylist from '../page/classifylist.vue'
import history from '../page/Apphis.vue'
import cpsShare from '../page/cpsShare.vue'
import cpsDetail from '../page/cpsDetail.vue'
import cpsShop from '../page/cpsShop.vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

 const router = new VueRouter({
  routes: [
    { path: '/index', component: index},
    { path: '/list/:type',component: list},
    { path: '/classifylist',component: classifylist},
    { path: '/history',component: history},
    { path: '/cpsShare',component: cpsShare},
    { path: '/cpsDetail',component: cpsDetail},
    { path: '/cpsShop',component: cpsShop},
  ]
})

router.beforeEach((to, from, next) => {
    // console.log('navigation-guards');
    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    next()
});
router.afterEach((to, from, next) =>{
    console.log(to)
    if(to.fullPath.indexOf('index') >= 0){
        document.title = "我的订单"
    }else if(to.fullPath.indexOf('classifylist') >= 0) {
        document.title = "分类查找订单"
    }

})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js